import { render, staticRenderFns } from "./ShopDialog.vue?vue&type=template&id=981e73ca&scoped=true"
import script from "./ShopDialog.vue?vue&type=script&lang=js"
export * from "./ShopDialog.vue?vue&type=script&lang=js"
import style0 from "./ShopDialog.vue?vue&type=style&index=0&id=981e73ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981e73ca",
  null
  
)

export default component.exports